import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { BaseService } from './base';
import { ConfiguredAttachment } from '../models';

/**
 * The files configured against a Document, for the email screen to list before sending.
 */
@Injectable({
  providedIn: 'root',
})
export class ConfiguredAttachmentService extends BaseService {
  protected constructor() {
    super('DocumentAttachment');
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }

  /**
   * What would be attached to an email for this record.
   *
   * ⚠️ The API resolves the customer's country using the same calls the send itself uses, so this
   * is a preview of the real thing rather than a second opinion. Without a document type or a
   * record there is nothing to resolve, so it answers empty without troubling the server.
   */
  forEmail(documentType: string, reportId: string): Observable<ConfiguredAttachment[]> {
    if (!documentType || !reportId) {
      return of([]);
    }

    return this.httpService.get<ConfiguredAttachment[]>(
      `${this.apiUrl}/ForEmail/${encodeURIComponent(documentType)}/${reportId}`,
    );
  }
}
